module.exports = __webpack_public_path__ + "static/jumping-5754e8aab51738b1625b1cf43a299a0f.jpg";